function extractAndInsertDimensions() {
  const hiddenContainer = document.querySelector('.wmp-dimensions .hidden');
  if (!hiddenContainer) {
    console.error('Container .wmp-dimensions .hidden not found');
    return;
  }

  const svgContainer = document.querySelector('.product-dimensions-one-img svg');
  if (!svgContainer) {
    console.error('SVG-container .product-dimensions-one-img svg not found');
    return;
  }

  const dimensionsGlasses = {
    lensWidth: { mm: null, in: null },
    lensHeight: { mm: null, in: null },
    noseBridge: { mm: null, in: null },
    hingeToHinge: { mm: null, in: null },
    templeSize: { mm: null, in: null },
  };

  const dimensionsJewelry = {
    length: { mm: null, in: null },
    width: { mm: null, in: null },
    height: { mm: null, in: null },
  };

  const dimensionKeysGlasses = [
    { key: 'Lens Width', name: 'lensWidth', svgId: 'lens' },
    { key: 'Lens Height', name: 'lensHeight', svgId: 'height' },
    { key: 'Nose Bridge', name: 'noseBridge', svgId: 'bridge-text' },
    { key: 'Hinge to Hinge', name: 'hingeToHinge', svgId: 'width' },
    { key: 'Temple Size', name: 'templeSize', svgId: 'temple' },
  ];

  const dimensionKeysJewelry = [
    { key: 'Length', name: 'length', svgId: 'length' },
    { key: 'Width', name: 'width', svgId: 'width' },
    { key: 'Height', name: 'height', svgId: 'height' },
  ];

  const spans = hiddenContainer.querySelectorAll('span');
  spans.forEach((span) => {
    const text = span.textContent.trim();

    dimensionKeysGlasses.forEach(({ key, name }) => {
      if (text.includes(key)) {
        const mmMatch = text.match(/(\d+)mm/);
        if (mmMatch) {
          dimensionsGlasses[name].mm = parseInt(mmMatch[1], 10);
        }
      } else if (text.includes('inches')) {
        const inMatch = text.match(/\((\d+\.\d+)\s*inches\)/);
        if (inMatch) {
          const prevSpan = span.previousElementSibling;
          if (prevSpan) {
            const prevText = prevSpan.textContent.trim();
            dimensionKeysGlasses.forEach(({ key, name }) => {
              if (prevText.includes(key)) {
                dimensionsGlasses[name].in = parseFloat(inMatch[1]);
              }
            });
          }
        }
      }
    });

    dimensionKeysJewelry.forEach(({ key, name }) => {
      if (text.includes(key)) {
        const mmMatch = text.match(/(\d+)mm/);
        if (mmMatch) {
          dimensionsJewelry[name].mm = parseInt(mmMatch[1], 10);
        }
      } else if (text.includes('inches')) {
        const inMatch = text.match(/\((\d+\.\d+)\s*inches\)/);
        if (inMatch) {
          const prevSpan = span.previousElementSibling;
          if (prevSpan) {
            const prevText = prevSpan.textContent.trim();
            dimensionKeysJewelry.forEach(({ key, name }) => {
              if (prevText.includes(key)) {
                dimensionsJewelry[name].in = parseFloat(inMatch[1]);
              }
            });
          }
        }
      }
    });
  });

  const isJewelrySvg = svgContainer.querySelector('text#length');
  const dimensionKeys = isJewelrySvg ? dimensionKeysJewelry : dimensionKeysGlasses;
  const dimensions = isJewelrySvg ? dimensionsJewelry : dimensionsGlasses;

  dimensionKeys.forEach(({ name, svgId }) => {
    const textElement = svgContainer.querySelector(`text#${svgId}`);
    if (textElement) {
      const mmTspan = textElement.querySelector('tspan:first-child');
      const inTspan = textElement.querySelector('tspan:last-child');
      if (mmTspan && dimensions[name].mm !== null) {
        mmTspan.textContent = `${dimensions[name].mm}mm`;
      }
      if (inTspan && dimensions[name].in !== null) {
        inTspan.textContent = `(${dimensions[name].in} ${name === 'hingeToHinge' ? 'in' : 'inches'})`;
      }
    } else {
      console.warn(`Element text#${svgId} wasn't found at SVG`);
    }
  });

  const hasDimensions = Object.values(dimensions).some((dim) => dim.mm !== null);
  if (hasDimensions) {
    document.querySelector('.wmp-dimensions').classList.add('wmp-dimensions--shown');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  extractAndInsertDimensions();
});
